import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AdminNavComponent } from '../admin-nav/admin-nav.component';

/**
 * A section of the admin panel: the top nav, a row of tabs, and the page.
 *
 * The panel had seven top-level pages, each rendering the nav itself, and
 * three of them were the same population seen from a different side (every
 * account, the engaged ones, the ones still just a name). Sections put those
 * side by side as tabs. The tabs come from the route config - any child route
 * carrying \`data.tab\` is one - so adding a tab is adding a route, and the
 * shell never has to know which section it is serving.
 */
@Component({
  selector: 'app-admin-section',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive, AdminNavComponent],
  template: `
    <app-admin-nav></app-admin-nav>
    <nav class="tabs" *ngIf="tabs.length > 1">
      <a *ngFor="let t of tabs" [routerLink]="t.path" routerLinkActive="on">{{ t.label }}</a>
    </nav>
    <router-outlet></router-outlet>
  `,
  styles: [
    `
      .tabs {
        display: flex;
        gap: 22px;
        margin: 14px 28px 0;
        border-bottom: 1px solid rgba(18, 51, 47, 0.14);
        font-family: 'Instrument Sans', system-ui, sans-serif;
      }
      a {
        padding: 8px 2px 10px;
        margin-bottom: -1px;
        font-size: 13.5px;
        font-weight: 600;
        color: #5e5a57;
        text-decoration: none;
        border-bottom: 2px solid transparent;
      }
      a:hover {
        color: #12332f;
      }
      a.on {
        color: #12332f;
        border-bottom-color: #1f6f66;
      }
    `,
  ],
})
export class AdminSectionComponent {
  readonly tabs: { path: string; label: string }[];

  constructor(route: ActivatedRoute) {
    this.tabs = (route.routeConfig?.children ?? [])
      .filter((r) => r.path && r.data?.['tab'])
      .map((r) => ({ path: r.path as string, label: r.data?.['tab'] as string }));
  }
}
